import { createContext, type FC, type ReactNode, useContext } from "react";

const InteractiveReferenceBoundaryContext = createContext(false);

/**
 * Marks a subtree as inside an interactive reference. The outer reference owns
 * the interaction, so references nested within it render as plain content
 * rather than as links inside a link.
 */
export const InteractiveReferenceBoundary: FC<{ children: ReactNode }> = ({
  children,
}) => (
  <InteractiveReferenceBoundaryContext.Provider value={true}>
    {children}
  </InteractiveReferenceBoundaryContext.Provider>
);

export function useIsInsideInteractiveReference(): boolean {
  return useContext(InteractiveReferenceBoundaryContext);
}
